<template>
  <div :class="['input-integer', {'no-mt': removeMT}]">
    <input type="number" v-model="integerValue" /> <span v-show="unit !== ''">{{ unit }}</span>
    <div class="extra">{{extra}}</div>
  </div>
</template>

<script>
export default {
  name: 'input-integer',
  props: [ 'settingKey', 'unit', 'extra', 'removeMT' ],
  computed: {
    integerValue: {
      get () {
        let configuration = this.$store.state.settingsPage.configuration
        if (this.settingKey in configuration) {
          return configuration[this.settingKey].value
        }
        return ''
      },
      set (value) {
        let item = {
          key: this.settingKey,
          value: value
        }
        this.$store.commit('settingsPage/setConfigurationItem', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-integer > * {
  display: inline-block;
  vertical-align: middle;
  margin-top: 5px;
}
.input-integer.no-mt > * {
  margin-top: 0;
}
input[type="number"] {
  font-size: 14px;
  padding: 7px 10px;
  display: inline-block;
  width: 200px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

span {
  font-size: 12px;
  background-color: #555;
  color: #fff;
  padding: 9px 10px 10px;
  margin-left: -5px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.extra{
  display: block;
  font-size: 12px;
  color: #777;
}

@media only screen and (max-width: 430px) {
  .input-integer {
    display: grid;
    grid-template-areas: "a b"
                          "c c";
    grid-auto-columns: 3fr 1fr;
    input[type="number"] {
      grid-area: a;
      width: 100%;
    }

    span {
      grid-area: b;
      width: 100%;
    }

    div.extra {
      grid-area: c;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Settings/controls/InputInteger.vue